















































































import { Component, Mixins, Vue } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import DocPreviewDialog from '@/components/DocPreviewDialog.vue';
import { Getter, Mutation } from 'vuex-class';
import { OverviewLayoutITF } from '@/interfaces';
import moment from 'moment';


interface SendPlanningRec {
    driver_id: number;
}

@Component({
  components: {
    DocPreviewDialog
  },
  metaInfo() {
    return {
      title: 'Planning'
    };
  }
})
export default class PlanningOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public filterName = this.getTableCfg(this.tableCfg, 'filterName');
  public tableLoading = false;
  public dialogSendPlanning = false;
  public qparams: any = {
      calendar_week: false,
      is_pilot: false,
      hide_finished: false,
      year: moment().year(),
      weeknr: moment().isoWeek()
    };
  public recSendPlanning: SendPlanningRec = {driver_id: 0};
  public tableData: any = {};

  @Getter('getFilters')
  public getFilters!: (name: string) => object;

  @Mutation('setFilters')
  public setFilters;

  public getDayOfTheWeek(date) {
    moment.locale('nl-BE');
    return moment(date).format('dddd');
  }

  public isToday(date) {
    return date === moment().format('YYYY-MM-DD');
  }

  public getEntryTime(vrec) {
    if (vrec.customer_begin_timestamp) {
      return '[' + Vue.filter('timestamp_time')(vrec.customer_begin_timestamp) + ']';
    } else /*if (vrec.begin_timestamp !== vrec.end_timestamp)*/ {
      return '[' + Vue.filter('timestamp_time')(vrec.begin_timestamp) + ']';
    }
    // return '[??:??]';
  }

  public getEntryClass(vrec) {
    // console.log(vrec.id, vrec.is_underway, vrec.is_escort_checked, vrec.is_hour_not_known_yet)
    if (this.qparams.is_pilot === true) {

      if (!vrec.is_escort_checked) {
        if (vrec.is_first_job) {
          return 'green lighten-4';
        } else  {
          return 'yellow lighten-4';
        }
      }

      //   // console.log(vrec.begin_timestamp, vrec.end_timestamp, vrec.customer_begin_timestamp);
      //   if (moment.utc(vrec.begin_timestamp).local().hour() > 7) {
      //     return 'green';
      //   } else {
      //     return 'blue';
      //   }
      // }
    }
  }

  public previousWeek() {
    this.qparams.weeknr -= 1;
    if (this.qparams.weeknr <= 0) {
      this.qparams.year -= 1;
      this.qparams.weeknr = 52;
    }
    this.refreshTable();
  }

  public nextWeek() {
    this.qparams.weeknr += 1;
    if (this.qparams.weeknr > moment().isoWeeksInYear()) {
      this.qparams.year += 1;
      this.qparams.weeknr = 1;
    }
    this.refreshTable();
  }

  public getHeight() {
    // Navbar + header + footer = 200px
    return window.innerHeight - 200 + 'px';
  }

  public getVehicleData(index: number, vehicleId: string) {
    const vehicleData = this.tableData.table[index].vehicles[vehicleId];
    if (vehicleData) {
      // console.log(index, vehicleId, vehicleData);
      return vehicleData;
    }
    return [];
  }
  public refreshTable() {
    this.getTableData();
  }
  public async getTableData() {
    this.tableLoading = true;
    this.setFilters({
      name: this.filterName,
      value: this.qparams
    });
    const response = await this.api.getData(this.$store, this.apiUrl, this.qparams);
    if (response) {
      this.tableData = response.data;
    }
    this.tableLoading = false;
  }

  public async createReport() {
    const response = await this.api.getData(this.$store, '/jobs/planningreport', this.qparams);
    if (response) {
      const data: any = response.data;
      const ref: any = this.$refs.docpreview;
      ref.openurl(data.url);
    }
  }

  public async emailReport() {
    const response = await this.api.getData(this.$store, '/jobs/planningreport', this.qparams);
    if (response) {
      const data: any = response.data;
      const ref: any = this.$refs.docpreview;
      ref.openurl(data.url);
    }
  }

  public startSendPlanning() {
    this.dialogSendPlanning = true;
  }

  public async executeSendPlanning() {
    const rec = {...this.qparams};
    Object.assign(rec, this.recSendPlanning);
    const response = await this.api.postAction(this.$store, '/jobs/emailreport', rec);
  }

  public mounted() {
    const filters = this.getFilters(this.filterName);
    if (filters) {
      this.qparams = filters;
    }
    this.getTableData();
  }
}
